import { SquaresFour, Lightning, BookOpen, PuzzlePiece, BookBookmark, Trophy, NotePencil } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { AreaNode, Matrix } from "../diagrams";

const MODES = [
  { icon: Lightning, label: "Quick Practice", purpose: "Short, focused skill reps", tone: "orange" },
  { icon: BookOpen, label: "Story Adventures", purpose: "Learn inside a tale", tone: "blue" },
  { icon: PuzzlePiece, label: "Puzzles", purpose: "Playful problem-solving", tone: "teal" },
  { icon: BookBookmark, label: "Reading Journeys", purpose: "Read & comprehend", tone: "yellow" },
  { icon: Trophy, label: "Daily Challenges", purpose: "A fun daily spark", tone: "orange" },
  { icon: NotePencil, label: "Homework", purpose: "Tasks from grown-ups", tone: "teal" },
];

export function ModesSection() {
  return (
    <SectionShell
      id="modes"
      eyebrow="Learning Modes"
      eyebrowIcon={SquaresFour}
      title="Many ways into the same skills"
      description="One topic can be learned in several ways — a quick practice, a story, a puzzle. Every mode plugs into the same subjects and feeds the same progress, so children can learn the way that suits them today."
    >
      <div className="space-y-8">
        <Showcase title="Six learning modes" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {MODES.map((m) => (
              <AreaNode key={m.label} icon={m.icon} label={m.label} purpose={m.purpose} tone={m.tone} />
            ))}
          </div>
        </Showcase>

        <Showcase title="How modes connect to subjects & progress">
          <Matrix
            firstColLabel="Mode"
            columns={["Subjects", "Best for", "Feeds progress"]}
            rows={[
              { label: "Quick Practice", values: ["Maths · English", "All years", "Mastery"] },
              { label: "Story Adventures", values: ["Maths · English", "Years 1–3", "Mastery"] },
              { label: "Puzzles", values: ["Maths", "Years 2–6", "Applied skills"] },
              { label: "Reading Journeys", values: ["English", "All years", "Comprehension"] },
              { label: "Daily Challenges", values: ["Mixed", "All years", "Streak + XP"] },
              { label: "Homework", values: ["Set subject", "All years", "History + mastery"] },
            ]}
          />
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default ModesSection;
